import React from 'react'
import PanelHeader from 'wix-base-ui/lib/panels/panelHeader'
import Button from 'wix-base-ui/lib/controls/button'
import RadioButtons from 'wix-base-ui/lib/controls/radioButtons'
import TextInput from 'wix-base-ui/lib/controls/textInput'
import symbols from './symbols'
import _ from 'lodashParts'

const NO_LINK = 'noLink'
const WEB_LINK = 'webLink'

class DefaultLinkDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            linkType: NO_LINK,
            webLinkValue: props.value
        }
    }

    onRadioButtonClick(value) {
        this.setState({linkType: value})
    }

    onWebLinkInputChange(value) {
        this.setState({webLinkValue: value})
    }

    cancel() {
        this.props.onCancel()
    }

    saveLink() {
        let link = null

        if (this.state.linkType === WEB_LINK) {
            link = this.state.webLinkValue
        }

        this.props.onDialogClosed(link)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            linkType: nextProps.value ? WEB_LINK : NO_LINK,
            webLinkValue: nextProps.value
        })
    }

    render() {
        const self = this

        function renderNoLinkTab() {
            return (
                <div>
                    <div className="symbol-container">
                        <svg className="symbol symbol-noLink"
                             {...symbols.noLink.svg}
                             dangerouslySetInnerHTML={{__html: symbols.noLink.content}}>
                        </svg>

                    </div>

                    <h3>This Element’s Not Linked</h3>
                    <p>Choose from the list of options to add a link to your element.</p>
                </div>
            )
        }

        function renderWebLinkTab() {
            return (
                <div>
                    <div className="control text-input-container">
                        <span className="control-title">
                            What's the web address (URL)?
                        </span>
                        <TextInput value={self.state.webLinkValue}
                                   placeholder="Paste it here..."
                                   onChange={value => self.onWebLinkInputChange(value)}/>
                    </div>
                </div>
            )
        }

        function renderLinkTab() {
            let tabContent = null

            switch (self.state.linkType) {
                case NO_LINK: tabContent = renderNoLinkTab()
                    break
                case WEB_LINK: tabContent = renderWebLinkTab()
                    break
            }

            return (
                <div className={'tab-content ' + self.state.linkType + '_tab'}>
                    {tabContent}
                </div>
            )
        }

        if (this.props.isOpen) {
            return (
                <div className="richtext-default-link-dialog modal-wrapper">
                    <div className="modal-inner-wrapper">
                        <PanelHeader
                            onClose={() => this.cancel()}
                            noHelpBtn={true}>
                            <span>What do you want to link to?</span>
                        </PanelHeader>
                        <div className="content-wrapper">
                            <div className="tab-header">
                                <RadioButtons value={this.state.linkType}
                                                 onChange={val => this.onRadioButtonClick(val)}
                                                 options={[
                                                     {value: NO_LINK, label: 'None'},
                                                     {value: WEB_LINK, label: 'Web address'}]} />
                            </div>
                            {renderLinkTab()}
                        </div>
                        <div className="footer">
                            <Button className="btn-confirm-secondary" onClick={() => this.cancel()}>Cancel</Button>
                            <Button className="btn-confirm-primary" onClick={() => this.saveLink()}>Done</Button>
                        </div>
                    </div>
                    <div className="background-mask" onClick={() => this.cancel()}></div>
                </div>
            )
        }

        return null
    }
}

DefaultLinkDialog.defaultProps = {
    isOpen: false,
    onDialogClosed: _.noop,
    onCancel: _.noop
}

DefaultLinkDialog.propTypes = {
    value: React.PropTypes.string,
    isOpen: React.PropTypes.bool,
    onDialogClosed: React.PropTypes.func,
    onCancel: React.PropTypes.func
}

module.exports = DefaultLinkDialog



// WEBPACK FOOTER //
// ./src/components/toolbar/defaultLinkDialog.jsx